    <div class="app-contact-matrix">
        <app-data-table
            [columns]="columns"
            [data]="tableData"
            [layoutFixed]="false"
            smallRowHeight="true"
        >
            <ng-container *cellTemplate="let level of 'departmentCellTemplate'; let departmentKey = dataField">
                @if (level.key !== 'total') {
            
                @let count = (data.Contacts | contactMatrixCount: level.key: departmentKey);
            
                @if (count === 0) {
                <span class="zero-value">0</span>
                } @else {
                <span class="a" (click)="viewContacts(level.key, departmentKey)">
                    {{ count }}
                </span>
                }
            
                } @else {
            
                @let total = (departmentKey | contactTotal: data.DepartmentTotals);
            
                @if (total === 0) {
                <span class="zero-value total-value">0</span>
                } @else {
                <span class="a total-value font-medium border-b-0" (click)="viewDepartmentContacts(departmentKey)">
                    {{ total | number }}
                </span>
                }
            
                }
            </ng-container>

            <ng-container *cellTemplate="let level of 'totalCellTemplate'">
                @if (level.key !== 'total') {
            
                @let total = (level.key | contactTotal: data.LevelTotals);
            
                @if (total === 0) {
                <span class="zero-value">0</span>
                } @else {
                <span class="a total-value font-medium" (click)="viewLevelContacts(level.key)">
                    {{ total | number }}
                </span>
                }
            
                } @else {
            
                @let totalContacts = data.TotalContacts ?? 0;
            
                @if (totalContacts === 0) {
                <span class="zero-value total-value">0</span>
                } @else {
                <span class="a total-value font-medium border-b-0" (click)="viewAllContacts()">
                    {{ totalContacts | number }}
                </span>
                }
            
                }
            </ng-container>
        </app-data-table>
    </div>
